import type {
  AysCode,
  AysCodeCodingSystem,
  AysCodingSystemClassification,
  AysCodingSystemSpecification,
} from '@bindoc-projects/code-domain-lib';
import { BdCodeTypeClassificationCondition } from './code-type-classification-condition';
import type { AysCodeSpectrumMatching } from '@bindoc-projects/code-spectrum-domain-lib';
import { CodeSpectrumMigrationCondition } from './code-spectrum-migration-condition';

export const BD_MAIN_DIAGNOSIS_CONTENT_CONDITION_ID = 'mainDiagnosis';
export const BD_MAIN_DIAGNOSIS_LEFT_ANCHORED_CONTENT_CONDITION_ID =
  'mainDiagnosisLeftAnchored';

export class BdMainDiagnosisContentCondition extends CodeSpectrumMigrationCondition<AysCode> {
  constructor(
    includes: AysCode[],
    excludes: AysCode[],
    codeSpectrumIds?: string[],
    codingSystem?: AysCodeCodingSystem,
    matching?: AysCodeSpectrumMatching,
    codeTypeSpecification?: AysCodingSystemSpecification,
    codeTypeClassification?: AysCodingSystemClassification,
    grouperVersionYear?: number,
  ) {
    super(
      BD_MAIN_DIAGNOSIS_CONTENT_CONDITION_ID,
      codeSpectrumIds,
      codingSystem,
      matching,
      codeTypeSpecification,
      codeTypeClassification,
      grouperVersionYear,
      includes,
      excludes,
    );
  }
}

export class BdMainDiagnosisLeftAnchoredContentCondition extends BdCodeTypeClassificationCondition<AysCode> {
  constructor(
    includes: AysCode[],
    excludes: AysCode[],
    codeSpectrumIds?: string[],
    codingSystem?: AysCodeCodingSystem,
    matching?: AysCodeSpectrumMatching,
    codeTypeSpecification?: AysCodingSystemSpecification,
    codeTypeClassification?: AysCodingSystemClassification,
    grouperVersionYear?: number,
    numberOfDigits?: number,
  ) {
    super(
      BD_MAIN_DIAGNOSIS_LEFT_ANCHORED_CONTENT_CONDITION_ID,
      includes,
      excludes,
      codeSpectrumIds,
      codingSystem,
      matching,
      codeTypeSpecification,
      codeTypeClassification,
      grouperVersionYear,
      numberOfDigits,
    );
  }
}
